import { useAuth } from './AuthContext';
import { AuthScreen } from './AuthScreen';

/**
 * Shown to someone who is signed in but is not one of ours — no admin doc, no
 * active partner account.
 *
 * That combination is reachable by anybody: the Google provider accepts any
 * Google account, so a stranger who finds the URL can complete a sign-in. This
 * is where they stop. The security rules refuse them the catalogue either way
 * (see `isMember()` in firestore.rules); this screen is so the refusal reads as
 * a closed door rather than a site that failed to load.
 *
 * Sign out is the only action, and it is the one that matters: the commonest
 * person to land here is an invited partner who picked the wrong Google account
 * out of the chooser, and they need a way back to it.
 */
export function NoAccessScreen() {
  const { user, partnerUser, signOutUser } = useAuth();
  const disabled = partnerUser?.status === 'disabled';

  return (
    <AuthScreen>
      <div className='tw:w-full tw:max-w-sm'>
        <h2 className='tw:font-serif tw:text-2xl tw:text-white'>
          {disabled ? 'Account disabled' : 'No access'}
        </h2>
        <p className='tw:mt-3 tw:text-sm tw:text-white/60'>
          {disabled
            ? 'This account has been disabled. Please contact Eighty Days if you think this is a mistake.'
            : 'Access is limited to Eighty Days administrators and our partners. If you were sent an invitation link, open it to set up your account.'}
        </p>
        {user?.email && (
          <p className='tw:mt-6 tw:text-xs tw:text-white/40'>
            Signed in as {user.email}
          </p>
        )}
        <button
          type='button'
          onClick={() => void signOutUser()}
          className='ed-btn-gold tw:mt-4 tw:w-full tw:rounded-sm tw:px-10 tw:py-3 tw:text-sm tw:tracking-[0.15em] tw:text-ed-black tw:uppercase'
        >
          Sign out
        </button>
      </div>
    </AuthScreen>
  );
}
